/**
 * Created by Анжелика on 25.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';

const initialState = {
    items: []
};

export function channelCards(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CHANNEL_CARDS_ADD:
            let items = state.items;
            const existsIndex = state.items.findIndex((item) => (item.channelID === action.channel.channelID));
            if (existsIndex > -1) {
                items.splice(existsIndex,1);
            }
            items.unshift(action.channel);
            return {
                ...state,
                items: items.slice(0, def.CHANNEL_CARDS_MAX_COUNT)
            };

        case actionTypes.LOAD_CHANNEL_CARDS_USER_CONFIG:
            return {
                ...state,
                items: action.items
            };

        case actionTypes.CLEAR_CHANNEL_CARDS:
            return {
                ...state,
                items: []
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/channelCards.js